<template>
    <el-dialog
            append-to-body
            :title="title"
            :visible.sync="dialogFormVisible"
            @close="close"
            :close-on-click-modal="false"
            width="1050px">

        <div class="user">
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                    <el-form-item label="标题">
                        <el-input v-model="query.keyword" placeholder="请输入标题"></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="query.question_type" placeholder="全部" clearable>
                            <el-option v-for="(item, index) in question_type_array" :label="item" :value="index" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <div class="block">
                            <span class="demonstration"></span>
                            <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!--内容-->
            <div class="product-content">
                <div class="table-wrap">
                    <el-table ref="table" size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="select">
                        <el-table-column type="selection" width="42" title="全选/反选"/>
                        <el-table-column prop="question_id" label="题目ID" width="80"></el-table-column>
                        <el-table-column prop="title" label="标题"></el-table-column>
                        <el-table-column prop="question_type_desc" label="类型" width="80"></el-table-column>
                        <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
                    </el-table>
                </div>
                <!--分页-->
                <div class="pagination">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            background
                            :current-page="query.page"
                            :page-size="query.list_rows"
                            layout="total, prev, pager, next, jumper"
                            :total="total"></el-pagination>
                </div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button size="medium" @click="close()">取 消</el-button>
            <el-button size="medium" type="primary" @click="handleAdd">确 定</el-button>
        </span>

    </el-dialog>
</template>

<script>
    import {questionList} from '@/api/education';
    export default {
        name: 'components-question-list',
        components: {

        },
        data() {
            return {
                title: '选择题目',
                dialogFormVisible: false,
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                /*当前编辑的对象*/
                userModel: {},
                query: {
                    question_type: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    status: 1,
                    list_rows: 10,
                },
                question_type_array: [],
                // 已选择的题目
                selection: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                this.getTableList();
                this.dialogFormVisible = true
            },
            /*获取列表*/
            getTableList() {
                this.loading = true
                questionList(this.query).then((result)=>{
                    this.loading = false
                    this.question_type_array = result.data.question_type
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            handleAdd() {
                if (this.selection.length === 0) {
                    this.$message({ type: 'error', message: '请选择试题' })
                }
                this.$emit('fetch-data', this.selection)
                this.close()
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
                this.query.question_type = val
            },
            // 关闭
            close() {
                this.dialogFormVisible = false
                // 取消选择
                this.$refs['table'].clearSelection();
            },
            // 选中操作
            select(selection) {
                this.selection = selection
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/education/components/question-list.vue